<template>
  <section class="search-bar" :class="color">
    <form class="search-bar__form" action>
      <div
        class="search-bar__form__group search-bar__form__group--category"
        :class="{ 'search-bar__form__group--error': $v.search.category.$error }"
      >
        <select v-model="search.category" @change.prevent="getState()">
          <option value="null" selected disabled hidden>
            Selecione a especialidade
          </option>
          <option
            :value="category.Codigo"
            v-for="category in categories"
            :key="category.Codigo"
          >
            {{ category.Nome }}
          </option>
        </select>
      </div>
      <div
        class="search-bar__form__group search-bar__form__group--state"
        :class="{ 'search-bar__form__group--error': $v.search.state.$error }"
      >
        <select v-model="search.state" @change.prevent="getCity()">
          <option value="null" selected disabled hidden>UF</option>
          <option :value="state" v-for="state in states" :key="state">
            {{ state }}
          </option>
        </select>
      </div>
      <div
        class="search-bar__form__group search-bar__form__group--city"
        :class="{ 'search-bar__form__group--error': $v.search.city.$error }"
      >
        <select v-model="search.city">
          <option value="null" selected disabled hidden>Cidade</option>
          <option :value="city" v-for="city in cities" :key="city">
            {{ city }}
          </option>
        </select>
      </div>
      <button
        type="submit"
        class="search-bar__form__submit"
        @click.prevent="handleSubmit()"
      >
        Buscar especialidade
      </button>
    </form>
    <div class="search-bar__erros" v-if="$v.$error">
      <TheAlert v-if="!$v.search.category.required"
        >Selecione a especialidade que você deseja.</TheAlert
      >
      <TheAlert v-if="!$v.search.state.required"
        >Selecione seu estado.</TheAlert
      >
      <TheAlert v-if="!$v.search.city.required"
        >Selecione a sua cidade.</TheAlert
      >
    </div>
    <div class="search-bar__logos">
      <section
        class="search-bar__logos__item"
        v-for="item in logos"
        :key="item.logo"
      >
        <figure>
          <img :src="getImage(item.logo)" alt />
        </figure>
        <p v-html="item.text"></p>
      </section>
    </div>
  </section>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { handlePartnerClick } from "@/services/gtm";

export default {
  data() {
    return {
      color: null,
      logos: [
        {
          logo: 'logo-preto-amorsaude',
          text: 'consulta a partir <br />de R$ <strong>26</strong>',
        },
        {
          logo: 'logo-preto-drogasil',
          text:
            'até <strong>35%</strong> em medicamentos',
        },
        {
          logo: 'logo-preto-raia',
          text:
            'até <strong>35%</strong> em medicamentos',
        },
        {
          logo: 'logo-preto-ultragaz',
          text:
            'desconto de 9% no botijão de gás',
        },
        {
          logo: 'logo-preto-refuturiza',
          text: '<strong>R$ 19,99</strong> por mês',
        },
      ],
      search: {
        category: null,
        state: null,
        city: null,
      },
      categories: [],
      states: [],
      cities: [],
    };
  },
  validations: {
    search: {
      category: {
        required,
      },
      state: {
        required,
      },
      city: {
        required,
      },
    },
  },
  methods: {
    ...mapActions(["setPartners"]),
    getImage(image) {
      return require(`./Section/assets/${image}.svg`);
    },
    getCategory() {
      this.$http
        .get(`Site/ListarCategorias`)
        .then((response) => {
          this.categories = response.data.ObjetoRetorno;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getState() {
      this.$http
        .get(
          `Empresa/ListarEstadosPorCategoria?codigoCategoria=${this.search.category}`
        )
        .then((response) => {
          this.states = response.data.ObjetoRetorno;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCity() {
      this.$http
        .get(
          `Empresa/ListarEstadosPorCategoria?codigoCategoria=${this.search.category}&uf=${this.search.state}`
        )
        .then((response) => {
          this.cities = response.data.ObjetoRetorno;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPartners() {
      this.$http
        .get(
          `Empresa/FiltrarParceiros?codigoCategoria=${this.search.category}&uf=${this.search.state}&nomeCidade=${this.search.city}&nome=`
        )
        .then((response) => {
          this.setPartners(response.data.ObjetoRetorno);
          if (this.$route.name === "Home") {
            this.$router.push({ name: "Partners" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        handlePartnerClick();
        this.getPartners();
      }
    },
  },
  components: {
    TheAlert: () => import("@/components/TheAlert.vue"),
  },
  created() {
    this.color = this.$route.name === "Home" ? "black" : "white";
    this.getCategory();
  },
};
</script>

<style lang="scss">
.search-bar {
  &.white {
    color: $color-white;
  }
  &.black {
    color: $color-black;
  }

  &__logos {
    margin-top: 24px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 12px;

    @include media(">small") {
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 16px;
    }
    @include media(">tablet") {
      grid-gap: 20px;
    }

    &__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      text-align: center;
      padding: 20px 16px;
      background: rgba(255, 255, 255, 0.4);
      border: 1px solid rgba(0, 0, 0, 0.14);
      border-radius: 16px;

      @include media(">tablet") {
        padding: 24px 20px;
      }

      figure {
        margin: 0;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          max-height: 40px;
          max-width: 100%;
          object-fit: contain;
        }
      }

      p {
        font-family: "Lato", sans-serif;
        font-size: 14px;
        line-height: 20px;
        color: $color-lightblue;

        strong,
        b {
          font-weight: 700;
        }
      }
    }
  }

  &__erros {
    padding-top: 16px;
    @include media(">=tablet") {
      margin: 0 auto;
      max-width: 920px;
    }
  }

  &__form {
    margin-top: 32px;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 12px;
    align-items: center;

    @include media(">=small") {
      grid-template-columns: minmax(0, 1fr) 100px minmax(0, 200px) auto;
    }

    &__group {
      position: relative;

      // Seta do select, desenhada em CSS para acompanhar a cor do novo layout.
      &::after {
        content: "";
        width: 8px;
        height: 8px;
        border-right: 2px solid $color-gray;
        border-bottom: 2px solid $color-gray;
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-70%) rotate(45deg);
        pointer-events: none;
      }

      &--error {
        &::before {
          content: url("../assets/icons/alert.svg");
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          right: 32px;
          transform: translateY(-50%);
          display: block;
        }
        select {
          border-color: $color-secondary;
        }
      }
    }

    select {
      width: 100%;
      padding: 14px 40px 14px 16px;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.18);
      border-radius: 8px;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: $color-gray;
      outline: none;
      appearance: none;
      cursor: pointer;
      transition: border-color 0.3s ease-in-out;

      &:focus {
        border-color: $color-gray;
      }
    }

    &__submit {
      width: 100%;
      padding: 14px 28px;
      background: $color-secondary;
      color: #000;
      font-family: "Lato", sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: normal;
      text-align: center;
      border: none;
      border-radius: 16px;
      cursor: pointer;
      outline: none;
      transition: 0.3s ease-in-out;

      &:hover {
        background: $color-red;
      }
    }
  }
}
</style>
